import AgenciesTitle from './AgenciesTitle';

export default AgenciesTitle;
